import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import MainScreenButton from '../../../../../components/forms/mainScreenButton';
import React from 'react';
import {useDispatch} from 'react-redux';
import {openPatientForm} from '../../../../../store/reducers/patientContext';

const CurrentClinicianButton = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const isNurse = props.nurse || props.nurseIP;

    const labelWithSpeciality = () => {
        if (!_.isEmpty(props?.value)) {
            return props?.value?.speciality?.__description;
        }
    };

    const getNursePath = () => {
        return props.nurse ? 'currentNurse' : 'currentNurseIP';
    };

    return (
        <MainScreenButton
            label={t(isNurse ? 'Current Nurse' : 'Current Clinician')}
            filled={props.value}
            value={props.value}
            disabled={props.disabled}
            onOpen={() => dispatch(openPatientForm(isNurse ? getNursePath() : 'currentClinician'))}
            extraLine={props.withSpeciality ? labelWithSpeciality : null}
            userPath={(props.withSpeciality || isNurse) ? 'who.__description' : '__description'}
            datePath={isNurse ? 'when' : 'timestamp'}
        />
    );
};

export default CurrentClinicianButton;